import React from "react";

import { LabelText, Swatch, ValueText, Wrap } from "./styles";

interface ColorSwatchProps {
    color: string | null;
    label: React.ReactNode;
    onClick: () => void;
    className?: string;
}

export const ColorSwatch = ({ color, label, onClick, className }: ColorSwatchProps) => (
    <Wrap type="button" onClick={onClick} className={className}>
        <Swatch $color={color} />
        <span>
            <LabelText>{label}</LabelText>
            <ValueText>{color || "не задан"}</ValueText>
        </span>
    </Wrap>
);
